import {optilePaymentAutorise} from './action-creators';
import {setLanguageChooserDisabled} from '../common/action-creators';
import {
    genericErrorHasOccurred
} from '../generic-error/action-creators';
import config from '../../config';
import {redirectTo} from '../../utils/helpers';
import localiseUrl from '../../utils/localiseUrl';

export const xhrRequestPaymentAutorise = (
    sessionId,
    language = 'en',
    availableLanguages = ['de', 'da', 'en', 'es', 'fr', 'nl'],
    dispatch
) => {
    const baseUrl = `${config.optile.api}/${language}/sessions/${sessionId}/bank/authorise`;

    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function getResp() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                dispatch(setLanguageChooserDisabled(true));
                dispatch(optilePaymentAutorise(data));

                if (data.redirectUrl) {
                    return redirectTo(data.redirectUrl, {method: 'GET', parameters: null});
                }

                if (data.redirect?.url) {
                    const {url, method, parameters} = data.redirect;
                    const localisedUrl = localiseUrl(url, language, availableLanguages);
                    return redirectTo(localisedUrl, {method, parameters});
                }
            }
            return dispatch(genericErrorHasOccurred(true));
        }
        return null;
    };

    xhr.open('POST', baseUrl, true);
    xhr.send();
};
